import Option from './Option';

export default Option;


// WEBPACK FOOTER //
// ./src/components/Others/ProductSelect/components/Option/index.tsx